export const resetPwdInitialValues = {
  newpwd: "",
  cofirmpwd: "",
};
